/**
 * onClickHandler: callback
 *
 * @param onClickHandler
 */
var onClickHandlerForNonInteractiveElements = (function (onClickHandler) {
  return {
    role: 'button',
    tabIndex: '0',
    onClick: onClickHandler,
    onKeyPress: function onKeyPress(event) {
      event.stopPropagation();
      var keycode = event.keycode,
          key = event.key;
      if (key === 'Enter') onClickHandler(event);else if (keycode === 13) onClickHandler(event);
    }
  };
});

export default onClickHandlerForNonInteractiveElements;
//# sourceMappingURL=onClickHandlerForNonInteractiveElements.js.map
